import React from 'react';
import BANNER from '../assets/other_banner.png';
import Header from './header';
import Search from './search';

import './headerBar.scss';

const HeaderBar = () => {
  return (
    <div className='header-bar'>
      <Header className='header-bar-header' />
      <img src={BANNER} alt='' width='100%' />
      <div className='header-bar-search'>
        <Search />
      </div>
    </div>
  );
};

export default HeaderBar;
